import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class AuthorizeApi {
  connectedUser$ = new BehaviorSubject<UserDto | null>(null);

  private readonly requestUrl: string = "/api/User";

  constructor(private http: HttpClient) {}

  getConnectedUser(): Observable<UserDto> {
    return this.http.get<UserDto>(`${this.requestUrl}/GetConnectedUser`);
  }

  login(u: UserDto): Observable<boolean> {
    return this.http.post<boolean>(`${this.requestUrl}/Login`, u);
  }

  logout(): Observable<boolean> {
    return this.http.get<boolean>(`${this.requestUrl}/Logout`);
  }
}

export interface UserDto {
  id: string;
  email: string;
  password: string;
}
